import _slicedToArray from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// see more https://nodejs.org/api/querystring.html
// TODO: it could be replaced with URLSearchParams - https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
export function parse(str) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "&";
  var eq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "=";
  return str.split(sep).reduce(function (params, pair) {
    var _pair$split$map = pair.split(eq).map(function (v) {
      return decodeURIComponent(v || "");
    }),
        _pair$split$map2 = _slicedToArray(_pair$split$map, 2),
        key = _pair$split$map2[0],
        value = _pair$split$map2[1];

    params[key] = value;
    return params;
  }, {});
}
export function stringify(obj) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "&";
  var eq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "=";
  return obj && Object.keys(obj).map(function (key) {
    return encodeURIComponent(key) + eq + encodeURIComponent(obj[key]);
  }).join(sep);
}